import React, { useEffect, useState } from "react";
import { FadeIn, SlideIn } from "./animations";
import { db } from "../../firebase";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";

const Partners = () => {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, "partners"), orderBy("orden", "asc"));

    const unsub = onSnapshot(
      q,
      (snap) => {
        const rows = snap.docs
          .map((d) => ({ id: d.id, ...d.data() }))
          .filter((p) => p.activo);
        setPartners(rows);
        setLoading(false);
      },
      (err) => {
        console.error("Error cargando partners:", err);
        setLoading(false);
      }
    );

    return () => unsub();
  }, []);

  return (
    <section className="relative z-10 w-full bg-[#E5E5E5] py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-6 sm:px-10 md:px-16">
        <FadeIn>
          <h2 className="text-2xl md:text-3xl font-bold text-[#00698F] text-center">
            Alianzas y partners
          </h2>
        </FadeIn>

        <FadeIn y={4}>
          <p className="mt-3 text-sm md:text-base text-[#00698F]/75 text-center max-w-2xl mx-auto">
            Si perteneces a alguna de estas alianzas, solicita tu cupón y úsalo
            al momento de agendar tu sesión en EKINE para acceder a beneficios
            preferenciales.
          </p>
        </FadeIn>

        {loading ? (
          <p className="mt-10 text-center text-sm text-slate-500">
            Cargando alianzas...
          </p>
        ) : partners.length === 0 ? (
          <p className="mt-10 text-center text-sm text-slate-500">
            Aún no hay alianzas activas.
          </p>
        ) : (
          <div className="mt-10 grid gap-6 md:gap-8 md:grid-cols-1">
            {partners.map((p, i) => (
              <SlideIn key={p.id} dir="up" delay={i * 0.06}>
                <article
                  className="
                    rounded-2xl bg-white
                    shadow-[0_18px_45px_-26px_rgba(0,0,0,0.4)]
                    border border-black/5
                    px-6 py-5
                    flex flex-col md:flex-row justify-between items-center
                    max-w-3xl mx-auto gap-6
                  "
                >
                  {/* TEXTO IZQUIERDA */}
                  <div className="flex-1">
                    <div className="flex items-start justify-between gap-3 mb-3">
                      <h3 className="text-lg md:text-xl font-semibold text-[#00698F]">
                        {p.nombre}
                      </h3>

                      <span
                        className="
                          inline-flex items-center rounded-full
                          bg-[#06b6fa] text-[white]
                          px-3 py-1 text-[0.7rem]
                          font-semibold uppercase tracking-wide
                        "
                      >
                        Beneficio exclusivo
                      </span>
                    </div>

                    <p className="text-sm text-[#00698F]/80 mb-3">
                      {p.descripcion}
                    </p>

                    {p.beneficio && (
                      <p className="text-sm font-semibold text-[#00698F] mb-2">
                        {p.beneficio}
                      </p>
                    )}

                    {p.instruccion && (
                      <p className="text-xs md:text-sm text-[#00698F]/70">
                        {p.instruccion}
                      </p>
                    )}
                  </div>

                  {/* LOGO DERECHA */}
                  {p.ruta_imagen && (
                    <div className="flex-none md:ml-4">
                      <img
                        src={p.ruta_imagen}
                        alt={p.nombre}
                        className="w-32 h-32 object-contain rounded-xl shadow-sm"
                      />
                    </div>
                  )}
                </article>
              </SlideIn>
            ))}
          </div>
        )}

        <FadeIn y={6}>
          <p className="mt-8 text-[0.75rem] md:text-xs text-[#00698F]/55 text-center max-w-2xl mx-auto">
            Para usar estos beneficios, selecciona cualquier servicio al agendar
            en EKINE y escribe tu cupón en el campo &quot;Cupón&quot; del
            formulario de reserva.
          </p>
        </FadeIn>
      </div>
    </section>
  );
};

export default Partners;
